import { TPODataContext } from 'contexts/TPOContext';
import { useContext, useEffect, useState } from 'react';
import { commonClassName } from 'components/organism/PriceSimulator/SimulationList/SimulationList';
import Breadcrumb from 'components/atoms/Breadcrumb';
import TabSwitchComponent from 'components/atoms/TabSwitch/TabSwitch';
import { tabsType } from 'types/pricingSimulator';
import { useNavigate } from 'react-router-dom';
import { trackEventMixpanel } from 'utils/mixpanel';
import { TPO_APP_LOADED, TPO_MAIN_TAB_SELECTED } from 'utils/mixpanelEventNames';

// Trade Promo Optimization Index Page
const TPOPage = () => {
    const navigate = useNavigate();
    const { breadcrumbItems, activeTab, setActiveTab, tabs } = useContext(TPODataContext);

    useEffect(() => {
        trackEventMixpanel(TPO_APP_LOADED);
    }, []);

    useEffect(() => {
        if (activeTab) {
            trackEventMixpanel(TPO_MAIN_TAB_SELECTED, {
                tab_name: activeTab?.label,
            });
        }
    }, [activeTab]);
    return (
        <section>
            <Breadcrumb style={{ marginBottom: 10 }} items={breadcrumbItems} />
            <div className={`${commonClassName} bg-white h-full relative `} id="tpo-index-page">
                <div className="flex gap-2 items-center">
                    <h2 className={`font-sm m-0 min-w-[60px] font-medium text-blackAlt `}>{activeTab?.headerLabel}</h2>
                    <div className="">
                        <TabSwitchComponent
                            activeTabKey={activeTab?.key}
                            onTabChange={function (tab: tabsType): void {
                                setActiveTab(tab);
                                navigate(tab?.url ?? '');
                            }}
                            tabs={tabs}
                        />
                    </div>
                </div>
                {activeTab?.component}
            </div>
        </section>
    );
};

export default TPOPage;
